import { combineReducers } from "redux";
import defaultReducer from "./defaultReducer";

const reducer = combineReducers({
  defaultReducer,
});

export default reducer;
